import { render, staticRenderFns } from "./StandaloneTaskRedirect.vue?vue&type=template&id=6eb05902"
import script from "./StandaloneTaskRedirect.vue?vue&type=script&lang=js"
export * from "./StandaloneTaskRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports